import { httpClient } from './httpClient';

type AccountSettings = {
  email: {
    name: string;
    value: string;
  };
  id: {
    name: string;
    value: number;
  };
  notifications: {
    name: string;
    value: boolean;
  };
  password: {
    name: string;
    value: string;
  };
};

export interface ContactUsPayload {
  email?: string;
  message: string;
}

export const SettingsApi = {
  async fetchSettings() {
    const { data } = await httpClient.get<AccountSettings>('/user/settings');

    return data;
  },

  async sendEmailVerification() {
    const { data } = await httpClient.patch(
      '/user/settings/email-verification'
    );

    return data;
  },

  async changeEmail(payload: { email: string }) {
    return httpClient.patch('/user/settings/email', payload);
  },

  async changePassword(payload: { password: string }) {
    return httpClient.patch('/user/settings/password', payload);
  },

  async changeSubscription(payload: { receive_email: boolean }) {
    return httpClient.patch('/user/settings/subscription', payload);
  },

  async sendEmailToSupport(payload: ContactUsPayload) {
    const { data } = await httpClient.post('/contact-us', payload);

    return data;
  },

  async confirmAge() {
    const { data } = await httpClient.patch('/user/settings/age-verification');

    return data;
  },

  async unsubscribeFromMailing() {
    const { data } = await httpClient.get('/user/do-not-sell');

    return data;
  },

  async deleteProfile() {
    return httpClient.delete('/user');
  },

  async fetchTerms() {
    const { data } = await httpClient.get<{ terms: string }>('/terms');

    return data;
  },

  async fetchPrivacyPolicy() {
    const { data } = await httpClient.get<{ policy: string }>('/policy');

    return data;
  },

  async fetchBillingPolicy() {
    const { data } = await httpClient.get<{ policy: string }>(
      '/billing-policy'
    );

    return data;
  },

  async fetchPublicBillingPolicy() {
    const { data } = await httpClient.get<{ policy: string }>(
      '/billing_policy'
    );

    return data;
  },

  async fetchRefundPolicy() {
    const { data } = await httpClient.get<{ policy: string }>('/refund-policy');

    return data;
  },

  async fetchTrackingPolicy() {
    const { data } = await httpClient.get<{ policy: string }>(
      '/tracking-policy'
    );

    return data;
  },

  async fetchComplianceStatement() {
    const { data } = await httpClient.get<{ policy: string }>(
      '/compliance-statement'
    );

    return data;
  },

  async fetchMailDisclosure() {
    const { data } = await httpClient.get<{ disclosure: string }>(
      '/mail-disclosure'
    );

    return data;
  },

  async fetchWashingtonHealth() {
    const { data } = await httpClient.get<{ washington_health_data: string }>(
      '/washington-health'
    );

    return data;
  },

  async fetchComplaintsPolicy() {
    const { data } = await httpClient.get<{ policy: string }>(
      '/complaints-policy'
    );

    return data;
  },

  async fetchContentRemovalPolicy() {
    const { data } = await httpClient.get<{ policy: string }>(
      '/content-removal-policy'
    );

    return data;
  },

  async fetchConsentPolicy() {
    const { data } = await httpClient.get<{ policy: string }>(
      '/consent-policy'
    );

    return data;
  },

  async fetchSiteInfo() {
    const { data } = await httpClient.get<{ address: string }>('/site-info');

    return data;
  },
};
